import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function libraryTaxStart({ currOutlet }) {
  pushClevertapEvent('Library Tax Start', {
    'Current Selected Outlet': currOutlet,
  });
}

export function libraryChangeOutlet({ previousOutlet, currOutlet }) {
  pushClevertapEvent('Library Tax Change Outlet', {
    'Previous Selected Outlet': previousOutlet,
    'Current Selected Outlet': currOutlet,
  });
}

export function libraryCreateTax({ tax, isAllOutlet }) {
  const eventName = isAllOutlet
    ? 'Library Tax Create All Outlet'
    : 'Library Tax Create One Outlet';
  pushClevertapEvent(eventName, {
    Name: tax.name,
    Value: tax.amount,
  });
}

export function libraryUpdateOneOutlet({ oldTax, newTax }) {
  pushClevertapEvent('Library Tax Update One Outlet', {
    'Old Name': oldTax.name,
    'Old Value': oldTax.amount,
    'New Name': newTax.name,
    'New Value': newTax.amount,
  });
}

export function libraryDeleteTax({ tax }) {
  pushClevertapEvent('Library Tax Delete', {
    Name: tax.name,
    Value: tax.amount,
  });
}
